export const siteInfo = {
  name: "想要XX",
  fullName: "想要XX 品牌介绍与资源查询平台",
  slogan: "了解品牌，从这里开始",
  intro:
    "想要XX 是一个面向公众与行业伙伴的品牌信息门户，整合品牌介绍、最新资讯与实用资源，帮助每一位关注者更全面、更高效地了解想要XX 及其相关领域。",
  founded: "2013",
  region: "全国",
  partnerCount: "180+",
  resourceCount: "320+",
  visitCount: "96万+",
  copyright: "© 2026 想要XX 品牌介绍与资源查询平台. All rights reserved.",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "品牌介绍", to: "/brand" },
  { label: "相关资讯", to: "/news" },
  { label: "资源查询", to: "/resources" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export const footerGroups = [
  {
    title: "内容导航",
    links: [
      { label: "品牌介绍", to: "/brand" },
      { label: "相关资讯", to: "/news" },
      { label: "资源查询", to: "/resources" },
      { label: "全站搜索", to: "/search" },
    ],
  },
  {
    title: "了解我们",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系我们", to: "/contact" },
      { label: "团队与发展", to: "/about" },
    ],
  },
  {
    title: "热门主题",
    links: [
      { label: "品牌历史", to: "/brand" },
      { label: "产品线", to: "/brand" },
      { label: "行业动态", to: "/news" },
      { label: "白皮书下载", to: "/resources" },
    ],
  },
];

export const friendlyLinks = [
  "行业观察网",
  "品牌研究院",
  "中小企业服务平台",
  "公共信息资源库",
  "数字营销周刊",
];

export const contactInfo = {
  phone: "400-800-2026",
  email: "hello@xiangyao-xx.com",
  address: "上海市浦东新区世纪大道 1888 号 想要XX 中心 26 层",
  hours: "周一至周五 09:00 - 18:00",
};